import React from 'react';

import Login from 'src/pages/authentication/Login';

const CompanyLoginPage = () => <Login withSSO />;
export default CompanyLoginPage;
